export function isObjectEmpty(myobject){
   return Object.keys(myobject).length === 0 && myobject.constructor === Object
}